import type { PaymentDemandCreateInput, PaymentDemandDto } from '@expeditor/shared';
import { apiClient } from './client';

export const paymentDemandsApi = {
  async listForShipment(shipmentId: string): Promise<PaymentDemandDto[]> {
    const { data } = await apiClient.get<PaymentDemandDto[]>(
      `/shipments/${shipmentId}/payment-demands`,
    );
    return data;
  },
  async createForShipment(
    shipmentId: string,
    dto: PaymentDemandCreateInput,
  ): Promise<PaymentDemandDto> {
    const { data } = await apiClient.post<PaymentDemandDto>(
      `/shipments/${shipmentId}/payment-demands`,
      dto,
    );
    return data;
  },
  async issue(id: string): Promise<PaymentDemandDto> {
    const { data } = await apiClient.post<PaymentDemandDto>(`/payment-demands/${id}/issue`);
    return data;
  },
  async pay(id: string): Promise<PaymentDemandDto> {
    const { data } = await apiClient.post<PaymentDemandDto>(`/payment-demands/${id}/pay`);
    return data;
  },
  async cancel(id: string): Promise<PaymentDemandDto> {
    const { data } = await apiClient.post<PaymentDemandDto>(`/payment-demands/${id}/cancel`);
    return data;
  },
};
